import { api } from '@fno/service/global.js'

export const getTeams = ({ schoolId }) => api
    .get(`/v2/schools/${schoolId}/teams`)
    .then(response => response.data)

export const patchTeam = ({ team }) => api
    .patch(`/v2/schools/${team.meta.schoolId}/teams/${team.id}`, { data: team })
    .then(response => response.data)

export const createTeam = ({ team }) => api
    .post(`/v2/schools/${team.meta.schoolId}/teams`, { data: team })
    .then(response => response.data)
